import { render, staticRenderFns } from "./TgWishcardBig.vue?vue&type=template&id=d9f6c7c0&scoped=true&"
import script from "./TgWishcardBig.vue?vue&type=script&lang=js&"
export * from "./TgWishcardBig.vue?vue&type=script&lang=js&"
import style0 from "./TgWishcardBig.vue?vue&type=style&index=0&id=d9f6c7c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f6c7c0",
  null
  
)

export default component.exports